import { render, staticRenderFns } from "./pointList.vue?vue&type=template&id=a738cfec&scoped=true"
import script from "./pointList.vue?vue&type=script&lang=js"
export * from "./pointList.vue?vue&type=script&lang=js"
import style0 from "./pointList.vue?vue&type=style&index=0&id=a738cfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a738cfec",
  null
  
)

export default component.exports